export default {
	academic: {
		title: 'مؤهلات علمية',
		degree: 'الشهادة',
		school: 'الجامعة/المدرسة',
		specification: 'التخصص',
		graduated: 'متخرج',
		year: 'السنة/سنة التخرج',
		gpa: 'المعدل',

		isGraduated: 'متخرج',
		isNotGraduated: 'غير متخرج',
	},

	language: {
		title: 'اللغة',
		name: 'اللغة',
		skill: 'المستوى',
	},

	computer: {
		title: 'مهارات الحاسوب',
		name: 'اسم البرنامج',
		skill: 'المستوى',
	},

	expertise: {
		title: 'مهارات آخرى',
		name: 'المهارة',
		skill: 'المستوى',
	},

	courses: {
		title: 'هل شاركت بأي دورات أو ورشات عمل في السابق؟',
		name: 'اسم الدورة/الورشة',
		date: 'التاريخ',
		duration: 'المدة(شهر)',
		place: 'المكان',
		organization: 'الجهة المانحة',
		certificate: 'مع شهادة',
		certificateNo: 'بدون شهادة',
	},

	validations: {
		degreeRequire: 'يجب إدخال الشهادة, ',
		schoolRequire: 'يجب إدخال الكلية/المدرسة, ',
		specificationRequire: 'يجب إدخال التخصص, ',
		averageInt: 'المعدل يجب ان يكون رقم, ',

		nameRequire: 'يجب إدخال الاسم, ',
		dateRequire: 'يجب إدخال التاريخ, ',
		durationInt: 'المدة يجب ان تكون رقم, ',
		organizationRequire: 'يجب إدخال الجهة المانحة, ',
	},
};
